import { Users, Tag, Gauge, Receipt, Settings, LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/inhabitants", label: "Mieszkańcy", icon: Users },
  { to: "/prices", label: "Ceny Jedn.", icon: Tag },
  { to: "/measurements", label: "Odczyty", icon: Gauge },
  { to: "/invoicing", label: "Rozliczenie", icon: Receipt },
  { to: "/settings", label: "Ustawienia", icon: Settings },
];
